import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "my-16" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "mt-8 mb-4"
}
const _hoisted_4 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, { class: "ma-0 pa-0" }, {
      default: _withCtx(() => [
        (_ctx.items)
          ? (_openBlock(), _createBlock(_component_v_carousel, {
              key: 0,
              "hide-delimiters": "",
              continuous: "",
              height: "100%",
              "show-arrows": _ctx.showArrows
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
                  return (_openBlock(), _createBlock(_component_v_carousel_item, {
                    key: i,
                    src: item.src,
                    height: "100%"
                  }, null, 8, ["src"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["show-arrows"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_alert, {
          class: "",
          elevation: "16",
          color: "rgba(0,0,0,0)"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h1", null, [
              _createElementVNode("a", {
                href: _ctx.headerLink.href,
                class: "display-1 font-weight-bold text-decoration-none"
              }, _toDisplayString(_ctx.headerLink.name), 9, _hoisted_2)
            ]),
            (_ctx.tags)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, index) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      class: "mr-2 mb-2",
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tag), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.descriptions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.descriptions, (description, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "font-weight-regular",
                      key: index,
                      innerHTML: description
                    }, null, 8, _hoisted_5))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.points)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 2,
                  color: "rgba(0,0,0,0.1)",
                  class: "mb-8"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.points, (point, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        innerHTML: point,
                        class: "font-weight-regular"
                      }, null, 8, _hoisted_6))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.links)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
                    return (_openBlock(), _createElementBlock("strong", { key: index }, [
                      _createVNode(_component_v_btn, {
                        href: link.href,
                        class: "mr-2 mb-2",
                        large: "",
                        outlined: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", null, _toDisplayString(link.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}